import React, { useState, useEffect, useRef } from 'react'
import { createUseStyles } from 'react-jss'
import { formatPrice } from '../../../helpers/format'
import theme from '../../../style/theme'

const useStyles = createUseStyles({
  h2: {
    fontSize: 30,
    marginTop: 60,
    lineHeight: 40
  },
  dfWidgetBox: {
    padding: 0,
    width: '100%',
    '& h3': {
      margin: 0,
      fontWeight: 700,
      fontSize: '16px !important',
      letterSpacing: '0.2px',
      lineHeight: '22px'
    },
    '& .active': {
      background: '#D9E1CC',
      '& h3, & span': {
        color: '#38524F'
      }
    }
  },
  dfSubsSection: {
    padding: '9px 15px',
    border: '1px solid #38524F',
    background: '#F1EFEA',
    cursor: 'pointer',
    position: 'relative',
    borderTopLeftRadius: '0px',
    borderTopRightRadius: '0px',
    '& h3': {
      fontSize: '14px',
      color: '#38524F'
    },
    dfUl: {
      ul: {
        fontSize: '14px',
        paddingLeft: 20,
        lineHeight: 25,
        fontWeight: 300,
        color: '#38524F'
      }
    },
    '& span': {
      fontWeight: 700,
      fontFamily: 'Morion'
    },
    '& ul': {
      color: '#38524F',
      paddingLeft: 20,
      fontSize: '14px'
    },
    '&.active ul': {
      color: '#38524F',
      paddingLeft: 20,
      fontSize: '14px'
    },
    '&.active h3': {
      color: '##38524F'
    }
  },
  dfOneTime: {
    padding: '9px 15px',
    background: '#F1EFEA',
    color: '#38524F',
    cursor: 'pointer',
    position: 'relative',
    border: '1px solid #38524F',
    borderBottomLeftRadius: '0px',
    borderBottomRightRadius: '0px',
    '& h3': {
      fontSize: '14px',
      color: '#38524F'
    },
    '& span': {
      position: 'absolute',
      top: 0,
      right: 0,
      padding: '9px 15px',
      fontWeight: 700,
      fontFamily: 'Morion',
      lineHeight: '22px',
      fontSize: '14px'
    }
  },
  dfAddToCart: {
    '& button': {
      border: '1px solid #38524F',
      background: '#fff',
      padding: '8px 30px',
      marginTop: 20,
      fontSize: 18,
      textTransform: 'uppercase',
      color: '#38524F'
    }
  },
  dfProductWrapper: {
    regPrice: {
      right: 0,
      textDecoration: 'line-through',
      fontSize: 15
    }
  },
  regPrice: {
    position: 'absolute',
    fontSize: 14,
    top: 9,
    textDecoration: 'line-through',
    right: 15
  },
  discountPrice: {
    position: 'absolute',
    fontSize: '14px',
    top: 9,
    right: 68
  },
  discountTag: {
    position: 'relative',
    backgroundColor: '#031F1C',
    color: '#D9E1CC !important',
    padding: '5px 16px',
    borderRadius: '30px',
    fontSize: '14px',
    fontWeight: 400,
    zIndex: 1,
    fontFamily: theme.fonts.body
  },
  frequencySelect: {
    width: '50%',
    borderRadius: 0,
    border: '1px solid #38524F',
    padding: '5px 16px 5px 16px',
    background: 'transparent',
    color: '#38524F',
    marginTop: '20px',
    fontSize: '14px',
    outline: 'none'
  },
  df_freq: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  customRadio: {
    width: '10px',
    height: '10px',
    border: '1px solid #38524F',
    backgroundColor: 'transparent',
    position: 'relative',
    marginRight: '10px',
    cursor: 'pointer',
    '&.selected': {
      '&::after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '4px',
        height: '4px',
        backgroundColor: '#38524F'
      }
    }
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center'
  },
  '@media (max-width: 1080px)': {
    frequencySelect: {
      fontSize: '14px'
    },
    dfSubsSection: {
      borderTopLeftRadius: '0px',
      borderTopRightRadius: '0px',
      '& h3': {
        fontSize: '27px'
      },
      '&.active ul': {
        fontSize: '14px'
      },
      '& ul': {
        fontSize: '14px'
      }
    },
    dfOneTime: {
      borderBottomLeftRadius: '0px',
      borderBottomRightRadius: '0px',
      '& h3': {
        fontSize: '14px',
        color: '#38524F'
      },
      '& ul': {
        fontSize: '14px'
      },
      '& span': {
        position: 'absolute',
        top: 0,
        right: 0,
        padding: '9px 15px',
        fontWeight: 700,
        fontFamily: 'Morion',
        lineHeight: '22px',
        fontSize: '14px'
      }
    },
    dfWidgetBox: {
      padding: 0,
      width: '100%'
    },
    discountPrice: {
      position: 'relative',
      top: 0,
      right: '0px',
      fontSize: '14px'
    },
    discountTag: {
      position: 'relative',
      top: 0,
      right: 0,
      marginLeft: '10px',
      display: 'inline-block'
    }

  },
  '@media (max-width: 850px)': {
    dfOneTime: {
      borderBottomLeftRadius: '0px',
      borderBottomRightRadius: '0px',
      '& h3': {
        fontSize: '16px',
        color: '#38524F'
      },
      '& ul': {
        fontSize: '15px'
      },
      '& span': {
        position: 'absolute',
        top: 0,
        right: 0,
        padding: '9px 15px',
        fontWeight: 700,
        fontFamily: 'Morion',
        lineHeight: '2.2vw',
        fontSize: '14px'
      },
      frequencySelect: {
        fontSize: '14px'
      }
    },
    dfSubsSection: {
      borderTopLeftRadius: '0px',
      borderTopRightRadius: '0px',
      '& h3': {
        fontSize: '27px'
      },
      '&.active ul': {
        fontSize: '20px'
      },
      '& ul': {
        fontSize: '20px'
      }
    }
  },
  '@media (max-width: 575px)': {
    frequencySelect: {
      fontSize: '13px'
    },
    dfSubsSection: {
      borderTopLeftRadius: '0px',
      borderTopRightRadius: '0px',
      '& h3': {
        fontSize: '27px'
      },
      '&.active ul': {
        fontSize: '13px'
      },
      '& ul': {
        fontSize: '13px'
      }
    },
    dfOneTime: {
      borderBottomLeftRadius: '0px',
      borderBottomRightRadius: '0px',
      '& h3': {
        fontSize: '27px',
        color: '#38524F'
      },
      '& ul': {
        fontSize: '13px'
      },
      '& span': {
        lineHeight: '22px'
      }
    },
    dfWidgetBox: {
      padding: 0,
      width: '100%',
      '& h3': {
        fontSize: '14px'
      }
    },
    discountPrice: {
      position: 'relative',
      fontSize: '14px',
      top: 0,
      right: '0px'
    },
    discountTag: {
      position: 'relative',
      top: 0,
      right: 0,
      marginLeft: '10px',
      display: 'inline-block'
    },

    regPrice: {
      top: 9,
      right: 15,
      fontSize: '14px'
    }
  },
  '@media (max-width: 340px)': {
    dfSubsSection: {
      '& h3': {
        fontSize: '20px'
      }
    },
    regPrice: {
      top: 20
    }
  }
})

function calculateDiscountedPrice (basePrice, planDescription) {
  const discountType = planDescription.split('=')[0]
  const discountValue = parseFloat(planDescription.split('=')[1])

  switch (discountType) {
    case 'PERCENTAGE':
      return basePrice - (basePrice * (discountValue / 100))
    case 'FIXED_PRICE':
      return discountValue
    case 'AMOUNT_OFF':
      return basePrice - discountValue
    default:
      return basePrice
  }
}

function calculateDiscountPercentage (originalPrice, discountedPrice) {
  if (originalPrice <= 0 || discountedPrice >= originalPrice) {
    return 0
  }
  const discount = originalPrice - discountedPrice
  return Math.round((discount / originalPrice) * 100)
}

function SubscriptionWidget ({ onSelectionChange, price, sellingPlans }) {
  const classes = useStyles()
  const [isSubscription, setIsSubscription] = useState(true)
  const [selectedPlan, setSelectedPlan] = useState(null)
  const subsSectionRef = useRef(null)
  const [discountedPrice, setDiscountedPrice] = useState(price)
  const [initialized, setInitialized] = useState(false)

  // console.log('💡 SubscriptionWidget received selling plans:', sellingPlans)
  // console.log('💰 Price:', price)
  const updateVariantSelection = (sellingPlanId, priceOverride = null) => {
    // console.log('🔄 Updating selling plan ID:', sellingPlanId)
    const currentPrice = priceOverride || (isSubscription ? discountedPrice : price)
    // console.log('🔄 Updating with price:', currentPrice, 'isSubscription:', isSubscription)
    onSelectionChange(sellingPlanId, currentPrice, isSubscription)
  }

  const handleSubscriptionChange = (subscribed) => {
    // console.log('🔄 Subscription toggled:', subscribed)
    setIsSubscription(subscribed)

    // If subscribing, use selected plan or first available
    if (subscribed) {
      // const planId = selectedPlan ? selectedPlan.id : (sellingPlans.length > 0 ? sellingPlans[0].id : null)
      const planToUse = selectedPlan || (sellingPlans.length > 0 ? sellingPlans[0] : null)
      // console.log('📝 Using plan ID for subscription:', planId)

      if (planToUse) {
        // Recalculate discounted price for subscription
        const newDiscountedPrice = calculateDiscountedPrice(price, planToUse.description)
        setDiscountedPrice(newDiscountedPrice)
        // console.log('💰 Subscription price set to:', newDiscountedPrice)

        // Immediately update parent with new price
        const sellingPlanIdToUse = planToUse.shopifySellingPlanId || planToUse.id
        updateVariantSelection(sellingPlanIdToUse, newDiscountedPrice)
      }
    } else {
      // Not subscribing - no plan ID, use regular price
      // console.log('📝 One-time purchase - clearing plan ID, using regular price:', price)
      setDiscountedPrice(price) // Reset to regular price for one-time purchase
      updateVariantSelection(null, price)
    }
  }

  const handleFrequencyChange = (event) => {
    const selectedPlanId = event.target.value
    // console.log('🔄 Plan selected with ID:', selectedPlanId)

    // Find the plan from its ID
    const plan = sellingPlans.find(p => p.id === selectedPlanId)

    if (plan) {
      console.log('📝 Found plan:', plan)
      setSelectedPlan(plan)

      // Calculate new discounted price immediately
      const newDiscountedPrice = calculateDiscountedPrice(price, plan.description)
      console.log('💰 New discounted price:', newDiscountedPrice)
      setDiscountedPrice(newDiscountedPrice)

      // Double check that we're using the correct selling plan ID
      // console.log('📝 Recharge plan ID:', plan.id)
      // console.log('📝 Shopify selling plan ID:', plan.shopifySellingPlanId)

      // Use shopifySellingPlanId if available, otherwise fall back to id
      const sellingPlanIdToUse = plan.shopifySellingPlanId || plan.id
      // console.log('📝 Using selling plan ID for cart:', sellingPlanIdToUse)

      // Immediately update parent component with new price
      updateVariantSelection(sellingPlanIdToUse, newDiscountedPrice)
    }
  } // Modify the initialization effect
  useEffect(() => {
    // Only initialize once
    if (sellingPlans.length > 0 && !initialized) {
      // console.log('🔄 Initializing with first plan:', sellingPlans[0])
      const initialPlan = [...sellingPlans]
        .sort((a, b) => {
          const getWeeks = str => {
            const match = str.match(/(\d+)\s*week/)
            return match ? parseInt(match[1], 10) : 0
          }
          return getWeeks(a.name) - getWeeks(b.name)
        })[0]
      setSelectedPlan(initialPlan)

      // Calculate the initial discounted price
      const initialDiscountedPrice = calculateDiscountedPrice(price, initialPlan.description)
      setDiscountedPrice(initialDiscountedPrice)

      // Make sure we're passing the correct selling plan ID on initialization
      const sellingPlanIdToUse = initialPlan.shopifySellingPlanId || initialPlan.id
      // console.log('🔄 Initial selling plan ID to use:', sellingPlanIdToUse)
      // console.log('🔄 Initial discounted price:', initialDiscountedPrice)

      // Immediately update parent with the initial subscription price
      updateVariantSelection(sellingPlanIdToUse, initialDiscountedPrice)

      // Mark as initialized to prevent re-initialization
      setInitialized(true)
    }
  }, [sellingPlans, price, initialized])
  // Effect to handle selectedPlan changes after initialization
  useEffect(() => {
    if (selectedPlan && initialized && isSubscription) {
      // Update the discounted price when selected plan changes
      const newDiscountedPrice = calculateDiscountedPrice(price, selectedPlan.description)
      if (newDiscountedPrice !== discountedPrice) {
        setDiscountedPrice(newDiscountedPrice)

        // Update parent component with new price
        const sellingPlanIdToUse = selectedPlan.shopifySellingPlanId || selectedPlan.id
        updateVariantSelection(sellingPlanIdToUse, newDiscountedPrice)
      }
    }
  }, [selectedPlan, price, initialized, isSubscription])
  // Modify the click simulation to avoid repeated calls
  useEffect(() => {
    if (subsSectionRef.current && sellingPlans.length > 0 && !initialized) {
      // console.log('🔄 Auto-selecting subscription option')
      // Instead of triggering a click, just set the state directly
      setIsSubscription(true)
    }
  }, [sellingPlans, initialized])

  if (!sellingPlans.length) {
    // console.log('⚠️ No subscription plans available')
    return null
  }

  const sortedPlans = [...sellingPlans].sort((a, b) => {
    const getWeeks = str => {
      const match = str.match(/(\d+)\s*week/)
      return match ? parseInt(match[1], 10) : 0
    }
    return getWeeks(a.name) - getWeeks(b.name)
  })

  return (
    <div className={classes.dfProductWrapper}>
      <div className={classes.dfWidgetBox}>
        <div
          ref={subsSectionRef}
          className={`${classes.dfSubsSection} ${isSubscription ? 'active' : ''}`}
          onClick={() => handleSubscriptionChange(true)}
        >
          <div className={classes.sectionHeader}>
            <div className={`${classes.customRadio} ${isSubscription ? 'selected' : ''}`}> </div>
            <h3>Subscribe + Save</h3>
          </div>
          <span className={classes.regPrice}>{formatPrice(price)}</span>
          <span className={classes.discountPrice}>${discountedPrice}</span>

          <div
            className={classes.df_freq}
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
            }}
          >
            <select
              onChange={handleFrequencyChange}
              value={selectedPlan ? selectedPlan.id : ''}
              className={classes.frequencySelect}
              onClick={(e) => e.stopPropagation()}
            >
              {sortedPlans.map(plan => {
                const cleanedName = plan.name.replace(/\s*\(\d+\s*week[s]?\)/i, '').trim()
                return (
                  <option
                    key={plan.id}
                    value={plan.id}
                    data-selling-plan-id={plan.id}
                    data-shopify-selling-plan-id={plan.shopifySellingPlanId || plan.id}
                  >
                    {cleanedName}
                  </option>
                )
              })}
            </select>
            {discountedPrice < price && (
              <span className={classes.discountTag}>
                  Save {calculateDiscountPercentage(price, discountedPrice)}%
              </span>
            )}
          </div>
          <div className={classes.dfUl}>
            <ul>
              <li>No commitment, cancel anytime</li>
              <li>Free shipping Australia wide</li>
              <li>100% money back guarantee</li>
            </ul>
          </div>
        </div>
        <div
          className={`${classes.dfOneTime} ${!isSubscription ? 'active' : ''}`}
          onClick={() => handleSubscriptionChange(false)}
        >
          <div className={classes.sectionHeader}>
            <div className={`${classes.customRadio} ${!isSubscription ? 'selected' : ''}`}> </div>
            <h3>Buy One Time</h3>
          </div>
          <span>{formatPrice(price)}</span>
        </div>
      </div>
    </div>
  )
}

export default SubscriptionWidget
